<!-- header -->
<mat-card>
  <mat-card-header class="justify-content-start align-items-center">
    <mat-card-title class="main-font">Hobby</mat-card-title>

    <div class="d-flex justify-content-between">
      <div class="d-flex flex-row ms-2">
        <button
          mat-mini-fab
          color="accent"
          class="fab-action"
          [matMenuTriggerFor]="menu"
          matTooltip="Aggiungi un hobby">
          <mat-icon class="text-white">add</mat-icon>
        </button>
        <!--         <button class="ms-2 icon-btn my-auto" [matMenuTriggerFor]="menu" matTooltip="Aggiungi un hobby">
          <mat-icon class="icon-btn">add</mat-icon>
        </button> -->
        <mat-menu #menu="matMenu">
          <div class="myMenu">
            <button
              mat-menu-item
              (click)="addHobby(parent_hobby.id)"
              *ngFor="let parent_hobby of all_hobby"
              (mouseover)="onMouseOver(parent_hobby.id)"
              [matMenuTriggerFor]="submenu">
              <img
                [src]="
                  utilityService.getSanitizeUrl(
                    parent_hobby.filestorage?.path ?? ''
                  )
                "
                class="menu my-auto cont" />

              {{ parent_hobby.alias }}
            </button>

            <button
              mat-menu-item
              class="hoveredBtn"
              data-bs-toggle="modal"
              data-bs-target="#hobbyModal"
              (click)="selectedHobby = null">
              <span> Richiedi macrocategoria </span>
            </button>
          </div>
        </mat-menu>

        <mat-menu #submenu="matMenu">
          <div class="myMenu">
            <button
              mat-menu-item
              *ngFor="let child of all_hobby?.[elementIndex]?.children"
              (click)="addHobby(child.id)">
              <img
                [src]="utilityService.getSanitizeUrl(child.filestorage.path)"
                class="menu my-auto cont" />
              {{ child.alias }}
            </button>

            <button
              (click)="initForm()"
              mat-menu-item
              class="hoveredBtn noBg"
              data-bs-toggle="modal"
              data-bs-target="#hobbyModal">
              <span> Richiedi microcategoria </span>
            </button>
          </div>
        </mat-menu>

        <button
          mat-mini-fab
          color="accent"
          class="fab-action"
          *ngIf="profile_hobby?.length != 0 && editControl == false"
          (click)="enableEditMode()"
          #editBtn
          matTooltip="Modifica">
          <mat-icon class="text-white">edit</mat-icon>
        </button>

        <button
          mat-mini-fab
          color="accent"
          class="fab-action"
          matTooltip="Fine Modifiche"
          *ngIf="editControl == true"
          (click)="enableEditMode()"
          #doneBtn>
          <mat-icon class="text-white">done</mat-icon>
        </button>
        <!--         <button class="ms-2 icon-btn" *ngIf="profile_hobby?.length != 0 && editControl == false"
          (click)="enableEditMode()" #editBtn matTooltip="Modifica">
          <mat-icon class="icon-btn">edit</mat-icon>
        </button> -->

        <!--         <button class="ms-2 icon-btn" *ngIf="editControl == true" (click)="enableEditMode()" #doneBtn>
          <mat-icon class="icon-btn" matTooltip="Fine Modifiche">done</mat-icon>
        </button> -->
      </div>
    </div>

    <div class="w-100 d-flex justify-content-end">
      <button
        (click)="initForm()"
        class="ms-4 miniBtn position-relative"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#hobbyModal"
        mat-fab
        color="white"
        matTooltip="Richiesta hobby"
        (click)="selectedHobby = null">
        <mat-icon class="position-absolute miniIcon right"
          >notification_add</mat-icon
        >
      </button>
    </div>
  </mat-card-header>

  <!-- content -->
  <mat-card-content>
    <div class="row justify-content-start">
      <div
        style="font-family: 'Montserrat', sans-serif"
        class="row my-4 ms-1 fs-5"
        *ngIf="profile_hobby?.length == 0">
        Nessun Hobby Presente.
      </div>

      <div
        class="row col-4 align-items-center p-4 justify-content-between"
        [ngClass]="{ cont: editControl == false }"
        *ngFor="let parent of profile_hobby">
        <div class="col-3">
          <div>
            <!-- <button mat-fab color="white" matTooltip="{{macro_hobby.hobby.hobby_category.length != 0 ? macro_hobby.hobby.macro_category :''}}"> -->

            <!-- bottone macrocategorie -->

            <!-- bottone macrocategorie in visualize mode -->
            <div>
              <button
                *ngIf="editControl == false"
                mat-fab
                color="white"
                [matTooltip]="
                  parent.hobbies.children.length != 0
                    ? parent.hobbies.alias
                    : ''
                ">
                <!-- <mat-icon class="icon-btn bg">{{parent.hobbies.filestorage.path}}</mat-icon> -->
                <div class="round-container">
                  <span class="flex">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(
                          parent.hobbies.filestorage.path
                        )
                      " />
                  </span>
                </div>
              </button>
            </div>

            <!-- bottone macrocategorie in edit mode -->

            <div>
              <button
                class="position-relative"
                *ngIf="editControl == true"
                mat-fab
                color="white"
                [matTooltip]="
                  parent.hobbies.children.length != 0
                    ? parent.hobbies.alias
                    : ''
                ">
                <mat-icon
                  class="icon-btn bg"
                  [ngClass]="{
                    darker:
                      parent.hobbies.children_count > 0 &&
                      parent.hobbies.children.length < 3 &&
                      parent.hobbies.children.length <
                        parent.hobbies.children_count
                  }"
                  >{{ parent.hobbies.img_path }}</mat-icon
                >
              </button>
            </div>

            <!-- add da update -->
            <div
              class="position-relative add-btn"
              *ngIf="
                editControl == true &&
                parent.hobbies.children_count > 0 &&
                parent.hobbies.children.length < 3 &&
                parent.hobbies.children.length < parent.hobbies.children_count
              "
              [matMenuTriggerFor]="menu"
              (click)="childHobbies(parent.hobbies.id)">
              <span
                class="badge badge-save text-bg-none position-absolute"
                matTooltip="aggiungi micro"
                ><mat-icon class="icon-btn">add</mat-icon></span
              >
            </div>

            <!-- bottone opzioni in aggiunta -->
            <mat-menu #menu="matMenu" class="mt-5">
              <button
                mat-menu-item
                *ngFor="let child of child_hobby"
                (click)="addHobby(child.id)">
                <span class="flex">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(child.filestorage.path)
                    "
                    class="menu my-auto cont" />{{ child.alias }}</span
                >
              </button>
            </mat-menu>
            <!-- fine add da update -->

            <!-- elimina macro all'hover -->
            <div
              class="position-relative"
              (click)="deleteHobbyUser(parent.hobbies)">
              <span class="badge badge-del text-bg-none position-absolute">
                <mat-icon class="icon-small">cancel</mat-icon></span
              >
            </div>
            <!-- elimina macro all'hover -->
          </div>
        </div>

        <div
          *ngIf="parent.hobbies.children.length == 0"
          class="col-8 justify-content-start">
          {{ parent.hobbies.alias }}
        </div>

        <div
          class="row col-9"
          [ngClass]="{
            'justify-content-end': parent.hobbies.children.length == 3
          }"
          *ngIf="parent.hobbies.children">
          <div class="col-4" *ngFor="let child of parent.hobbies.children">
            <!-- button microcategorie -->
            <div class="position-relative">
              <button
                class=""
                mat-mini-fab
                color="white"
                [matTooltip]="child.alias">
                <img
                  [src]="utilityService.getSanitizeUrl(child.filestorage.path)"
                  class="icon-btn sm my-auto rounded-circle" />
              </button>
            </div>

            <!-- logica placeholder -->
            <!-- <div class="position-relative d-flex justify-content-evenly flex-row" *ngIf="editControl == true">
              <button class="margin-right" *ngFor="let _ of [].constructor(parent.hobbies.children_count)" mat-mini-fab color="white">
                <img *ngIf="editControl == true" [src]="parent.hobbies.children.img_path" class="icon-btn sm my-auto">
              </button>
            </div> -->
            <!-- logica placeholder -->

            <!-- elimina micro -->
            <div class="position-relative" (click)="deleteHobbyUser(child)">
              <!--  *ngIf="editControl == true" -->
              <span
                class="badge badge-del-category text-bg-none position-absolute">
                <mat-icon class="icon-small">cancel</mat-icon></span
              >
            </div>
            <!-- fine elimina micro -->
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

  <!-- Modal -->
  <div
    class="modal fade"
    id="hobbyModal"
    tabindex="-1"
    data-bs-backdrop="static"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">
            Richiedi Hobby
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="cleanForm()"></button>
        </div>
        <div class="modal-body">
          <form class="d-flex flex-column" [formGroup]="requestForm">
            <mat-form-field>
              <mat-label>Nome Hobby</mat-label>
              <input matInput formControlName="title" type="text" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Inserire la descrizione</mat-label>
              <textarea
                matInput
                formControlName="description"
                type="text"></textarea>
            </mat-form-field>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            mat-raised-button
            class="main-font"
            data-bs-dismiss="modal"
            (click)="cleanForm()">
            Chiudi
          </button>
          <button
            type="button"
            [disabled]="!requestForm.valid"
            mat-raised-button
            class="main-font"
            color="accent"
            data-bs-dismiss="modal"
            (click)="addRequest()">
            Salva
          </button>
          <!-- function al click -->
        </div>
      </div>
    </div>
  </div>
</mat-card>
